<template>

	<div>
		<div class="white">
			<div class="row">
				<div class="col-20">

					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li>
									<LangSwitch type="single" v-bind:downloadCallback="getMarketsCompleteHandler" v-bind:callback="langChanged"></LangSwitch>
								</li>
								<!-- <li><a href="#">Code</a></li> -->
							</ul>
						</nav>

					</div>

				</div>
			</div>
		</div>

		<div v-if="permissions.add" class="btns-top">
			<router-link v-if="mainSlug !== 'pages'" class="btn btn-add fa fa-plus transition-fadeinup transition-delay-01" :to="`${entityid}/add`"></router-link>
			<router-link v-else class="btn btn-add fa fa-plus transition-fadeinup transition-delay-01" :to="`pages/${entityid}/add`"></router-link>
		</div>

		<div class="row" v-if="this.totalCount === 0">
			<div class="col-20">

				<div class="addFirstItem transition-fadeinup">
					<p>No items found!<br><br></p>
					<router-link class="btn transition-fadeinup transition-delay-01" :to="`${entityid}/add`">
						<span class="fa fa-plus"></span> Add first item
					</router-link>
				</div>

			</div>
		</div>

		<template v-if="nestable === 'true'">

			<ul class="data-view transition-fadeinup" v-if="this.totalCount > 0">
				<li class="headings">
					<span>{{ columns[0].translations.en.value }}</span>
					<div>
						<span>Published</span>
						<span v-if="mainSlug === 'pages'">Hide</span>
						<div class="btn-space" v-if="permissions.edit"></div>
						<div class="btn-space" v-if="permissions.delete"></div>
					</div>
				</li>
			</ul>

			<!-- Used for nestable lists -->
			<ul class="data-view transition-fadeinup draggable-container main-draggable-container" v-if="this.totalCount > 0">
				<ObjectOverviewItem v-for="instance in instancesTree"
					:key="instance.id"
					:data="instance"
					:instances="items"
					:columns="columns"
					:markets="markets"
					:linkedEntity="linkedEntity"
					:mainSlug="mainSlug"
					:permissions="permissions"
					:collapseToggleChangeHandlerCallback="collapseToggleChangeHandler"
					:stateToggleChangeHandlerCallback="stateToggleChangeHandler"
					:visibilityToggleChangeHandlerCallback="visibilityToggleChangeHandler"
					ref="instanceElement"
				></ObjectOverviewItem>
			</ul>

		</template>

		<template v-else>

			<!-- Used for everything except nestable lists -->
			<table cellpadding="0" cellspacing="0" class="data  transition-fadeinup" v-if="this.totalCount > 0">
				<thead v-if="columns">
				<tr>
					<th></th>
					<template v-if="columns.length === 0">
						<th></th>
					</template>
					<th v-for="column in columns" :key="column.id">
						<template v-if="sortable === 'true'">
							{{ column.translations.en.value }}
						</template>
						<template v-else>
							<button class="btn-sort" :data-table-column="column.name" :data-sort="direction(column.name)" @click="sortBtnClickHandler">{{ column.translations.en.value }}</button>
						</template>
					</th>
					<th>
						<template v-if="sortable === 'true'">
							Created
						</template>
						<template v-else>
							<button class="btn-sort" data-table-column="created" :data-sort="direction('created')" @click="sortBtnClickHandler">Created</button>
						</template>
					</th>
					<th>
						<template v-if="sortable === 'true'">
							Published
						</template>
						<template v-else>
							<button class="btn-sort" data-table-column="state" :data-sort="direction('state')" @click="sortBtnClickHandler">Published</button>
						</template>
					</th>
					<th v-if="mainSlug === 'pages'">Hide</th>
					<th></th>
					<th></th>
				</tr>
				</thead>

				<tbody v-if="activeLanguage" class="draggable-container main-draggable-container">
				<template v-for="item in items">
					<tr v-if="item.market === activeLanguage.id" v-bind:key="item.id" class="draggable-item" :data-uuid="item.uuid">
						<template v-if="sortable === 'true'">
							<td class="handle">
								<div class="grip"></div>
							</td>
						</template>
						<template v-else>
							<td></td>
						</template>

						<template v-if="columns.length === 0">
							<td></td>
						</template>

						<template v-for="column in columns">
							<template v-if="item.properties">
								<!-- <template v-if="item.properties[column.name]"> -->
									<td v-html="renderColumnField(item, items, markets, column, linkedEntity)" :key="column.id"></td>
								<!-- </template>
								<template v-else>
									<td :key="column.id"></td>
								</template> -->
							</template>
						</template>

						<td>
							{{item.created}}
						</td>

						<td class="toggle-wrapper">
							<a href="#" class="btn-multi-switch" :class="`${ getMultiSwitchClass(item.state) }`" :data-id="item.id" v-on:click="stateToggleChangeHandler">
								<input type="number" name="state-toggle" :value="item.state"> </a>
						</td>
						<td class="toggle-wrapper" v-if="mainSlug === 'pages'">
							<a href="#" class="btn-switch red" :class="{ 'active' : item.properties['hide-from-navigation'] === 'true' }" :data-id="item.id" v-on:click="visibilityToggleChangeHandler"></a>
						</td>
						<td class="btns">
							<template v-if="mainSlug === 'pages'">
								<router-link v-if="permissions.edit" :to="`pages/${entityid}/edit/${item.uuid}`"><i class="fa fa-pen"></i></router-link>
							</template>
							<template v-if="mainSlug === 'submissions'">
								<button :data-uuid="item.uuid" @click="openSidebarClickHandler"><i class="fa fa-eye"></i></button>
							</template>
							<template v-else>
									<router-link title="Edit this item" v-if="permissions.edit" :to="`${entityid}/edit/${item.uuid}`"><i class="fa fa-pen"></i></router-link>
							</template>
							<button class="fa fa-clone" title="Duplicate this item" :data-id="item.uuid" @click="duplicateClickHandler"></button>
							<a title="Delete this item" v-if="permissions.delete" href="#" class="btn-delete-confirm fa fa-trash-alt" :id="item.uuid"></a>
							<!-- <template v-else>
								<router-link v-if="permissions.edit" :to="`${entityid}/edit/${item.uuid}`"><i class="fa fa-pen"></i></router-link>
							</template>
							<a v-if="permissions.delete" href="#" class="btn-delete-confirm fa fa-trash-alt" :id="item.uuid"></a> -->
						</td>
						<td></td>
					</tr>
				</template>

				</tbody>
			</table>

			<div class="row ">
				<div class="col-20">
					<br>
					<br>
					<button class="btn" @click="downloadClickHandler">Download (.csv)</button>

				</div>
			</div>

		</template>

		<div class="bubble bubble-delete-confirm">
			<a href="" class="btn red btn-bubble-delete" v-on:click="deleteRecord">Confirm</a>
			<a href="" class="btn black btn-bubble-cancel">Cancel</a>
		</div>

		<Sidebar :type="'submission'" ref="sidebar" :data="sidebarData"></Sidebar>
	</div>

</template>

<script>

import Sidebar from '../../components/sidebars/Sidebar.vue'
import LangSwitch from '../../components/LangSwitch.vue'
import ObjectOverviewItem from './ObjectOverviewItem.vue'
import sortable from '../../modules/sortable.js'
import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'

export default {
	name: 'ObjectOverview',
	props: ['content'],
	data () {
		return {
			entityid: this.$route.params.entityid,
			items: null,
			activeLanguage: null,
			columns: null,
			totalCount: null,
			sortable: 'false',
			nestable: 'false',
			user: this.$store.state.user,
			permissions: {
				add: false,
				edit: false,
				delete: false
			},
			markets: null,
			linkedEntity: null,
			mainSlug: general.getMainSlug(),
			entity: null,
			instancesTree: null,
			sortProp: null,
			sortDirection: null,
			sidebarData: {
				saveCallbackFunction: this.sidebarSaveCallback,
				marketOffsetTop: null
			}
		}
	},
	components: {
		'Sidebar': Sidebar,
		'LangSwitch': LangSwitch,
		'ObjectOverviewItem': ObjectOverviewItem
	},

	created () {
		this.entityid = this.$route.params.entityid

		// update codebar
		this.$root.$emit('updateCodebar', this.entityid)

		this.fetchSavedSorting()

		this.body = document.querySelector('body')
		if (!this.entityid) {
			if (this.mainSlug === 'pages') this.entityid = 22
		}
		this.items = []
		this.activeLang = null
		this.fetchData()
	},

	methods: {
		direction (name) {
			if (name === this.sortProp) {
				return this.sortDirection
			} else {
				return ''
			}
		},

		langChanged (lang) {
			this.activeLanguage = lang
			if (this.nestable === 'true') this.filterOnLang()
		},

		fetchData () {
			this.body.classList.add('loading')
			var url = '/cms/api/entities?id=' + this.entityid
			xhrModule.get(url, this.getEntityCompleteHandler.bind(this))
		},

		getMarketsCompleteHandler (markets) {
			this.markets = markets.data
		},

		getEntityCompleteHandler (entity) {
			entity = entity.data
			this.entity = entity
			this.entityName = entity.name
			if (entity.settings.sortable) {
				this.sortable = entity.settings.sortable.value
				if (entity.settings.nestable) this.nestable = entity.settings.nestable.value
			}

			var permissions = general.checkPermissions(entity.privileges, this.user.roles)
			this.permissions = permissions

			// now we can define the columns that we want to show
			var properties = entity.properties
			var sortable = []
			for (var prop in properties) {
				if (!properties[prop].translations) continue
				if (!properties[prop].settings) continue
				if (properties[prop].settings.orderinoverview.value === '0') continue
				if (properties[prop].name === 'offset_left' || properties[prop].name === 'offset_right') continue
				sortable.push(properties[prop])
			}

			sortable.sort(function (a, b) {
				return a.settings.orderinoverview.value - b.settings.orderinoverview.value
			})

			// when we are displaying the pages we will have to remove and edit a few fields in order to get the correct layout
			if (this.mainSlug === 'pages') {
				for (var i = sortable.length - 1; i >= 0; i--) {
					if (sortable[i].name !== 'title') {
						sortable.splice(i, 1)
					}
				}
			}

			this.columns = sortable

			this.columnNames = []
			for (var key in this.columns) {
				this.columnNames.push(this.columns[key].name)
			}

			// now fetch all instances for this entity
			this.fetchInstances()
		},

		fetchInstances () {
			var url = '/cms/api/instances/ofEntity?entity=' + this.entityid
			xhrModule.get(url, this.getInstancesCompleteHandler.bind(this))
		},

		getInstancesCompleteHandler (instances) {
			var tempInstances = instances.data
			this.linkedEntity = instances.linked

			this.items = tempInstances
			this.findRealTextValuesForReferences(function () {
				if (!this.sortable || this.sortable === 'false') this.sortResults()
			}.bind(this))

			if (this.nestable === 'true') {
				this.filterOnLang()
			} else {
				this.totalCount = this.items.length
				this.body.classList.remove('loading')

				setTimeout(function () {
					this.checkSortable()
				}.bind(this), 100)
			}
		},

		findRealTextValuesForReferences: function (callback) {
			// we need to find all arrays and find their real text values so we can sort on them instead of the uuids
			var referenceFields = this.linkedEntity.references
			for (var i = this.items.length - 1; i >= 0; i--) {
				for (var ref in referenceFields) {
					var value = this.items[i].properties[ref]

					if (value) {
						if (!this.items[i]['ref-' + ref]) this.items[i]['ref-' + ref] = ''
						for (var v = 0; v < value.length; v++) {
							var languages = referenceFields[ref][value[v]]
							for (var lang in languages) {
								if (this.items[i].market === languages[lang].market) {
									this.items[i]['ref-' + ref] += languages[lang].properties.name
								}
							}
						}
					}
				}

				if (i === 0) {
					callback()
				}
			}
		},

		filterOnLang () {
			// filter out all languages that we don't need
			var filteredInstances = []
			for (var i = this.items.length - 1; i >= 0; i--) {
				if (this.items[i].market === this.activeLanguage.id) {
					// edit the title in case there is a referenced item
					if (this.items[i].properties.references !== '') {
						this.items[i].properties.title = this.items[i].properties.references + ' **'
					}

					filteredInstances.push(this.items[i])
				}

				if (i === 0) {
					// sort on offset_left
					filteredInstances.sort(function (a, b) {
						return a.properties.offset_left - b.properties.offset_left
					})

					this.createInstancesTree(filteredInstances)
				}
			}
		},

		createInstancesTree (filteredInstances) {
			// create tree array we will use to render nested items
			this.instancesTree = []

			// keep track of depth
			var depth = []

			// calculate the highest offset right and offset it with 1
			var totalRight = (filteredInstances.length * 2) + 1
			// add main depth
			depth.push({
				obj: this.instancesTree,
				left: 1,
				right: totalRight
			})

			for (var i = 0; i < filteredInstances.length; i++) {
				// preprare object for fieldstree
				var obj = {
					'id': filteredInstances[i].id,
					'children': []
				}

				var left = 1
				var right = 2

				var leftProp = filteredInstances[i].properties.offset_left
				var rightProp = filteredInstances[i].properties.offset_right

				if (leftProp) left = parseInt(filteredInstances[i].properties.offset_left)
				if (rightProp) right = parseInt(filteredInstances[i].properties.offset_right)

				// Find the correct depth of this item
				var depthFound = false
				var amountOfDepthsToDelete = 0
				for (var d = depth.length - 1; d >= 0; d--) {
					if (left > depth[d].left && right < depth[d].right) {
						depthFound = true
						var depthLength = depth.length
						amountOfDepthsToDelete = depthLength - (d + 1)
						if (amountOfDepthsToDelete > 0) depth.splice(d + 1, amountOfDepthsToDelete)
						break
					}

					if (d === 0 && !depthFound) {
						// go up to the main depth because the item should be in the main list
						amountOfDepthsToDelete = depth.length - 1
						depth.splice(1, amountOfDepthsToDelete)
					}
				}

				var lastDepth = depth[depth.length - 1]
				if (lastDepth.obj.children) {
					lastDepth.obj.children.push(obj)
				} else {
					lastDepth.obj.push(obj)
				}

				var difference = right - left
				if (difference !== 1) {
					// create new depth because this item has childs
					depth.push({
						id: filteredInstances[i].id,
						left: left,
						right: right,
						obj: obj
					})
				}

				if (i === filteredInstances.length - 1) {
					this.totalCount = this.instancesTree.length
					this.body.classList.remove('loading')

					setTimeout(function () {
						this.checkSortable()
					}.bind(this), 100)
				}
			}
		},

		checkSortable () {
			if (this.sortable === 'true') {
				if (this.sortableModule) return
				this.sortableModule = sortable({
					container: null,
					entityID: this.entityid,
					callback: this.sortCompleted.bind(this),
					nestable: this.nestable,
					collapsible: true
				})
				this.sortableModule.init()
			}
		},

		sortCompleted (newOffsets) {
			this.updatedInstanceCompleteHandler()

			// apply new offsets to all instances with these uuid's to prevent other languages from having outdated data
			for (var no = newOffsets.length - 1; no >= 0; no--) {
				for (var i = this.items.length - 1; i >= 0; i--) {
					if (newOffsets[no].uuid === this.items[i].uuid) {
						this.items[i].properties['offset_left'] = newOffsets[no]['offset_left']
						this.items[i].properties['offset_right'] = newOffsets[no]['offset_right']
					}
				}

				if (no === 0) {
					this.items.sort((a, b) => (a.properties['offset_left'] > b.properties['offset_left']) ? 1 : -1)
				}
			}
		},

		deleteRecord (e) {
			e.preventDefault()

			var target = e.currentTarget
			var uuid = target.getAttribute('data-id')

			var obj = {
				'entity': null,
				'uuid': null,
				'instance': []
			}

			// find all instances with this UUID and set their state to 5
			for (var i = this.items.length - 1; i >= 0; i--) {
				if (this.items[i].uuid === uuid) {
					if (!obj.entity) {
						obj.entity = this.entityid
						obj.uuid = this.items[i].uuid
					}

					obj.instance.push({
						'id': this.items[i].id,
						'market': this.items[i].market,
						'state': 5
					})
				}

				if (i === 0) {
					var json = JSON.stringify(obj)

					var url = '/cms/api/instances/save'
					xhrModule.post(url, json, this.deletedInstanceCompleteHandler.bind(this))
				}
			}
		},

		deletedInstanceCompleteHandler () {
			// all changes have been posted
			this.fetchData()
			this.updatedInstanceCompleteHandler()
		},

		collapseToggleChangeHandler (e) {
			var target = e.currentTarget
			target.classList.toggle('open')

			var parent = target.parentNode.parentNode.parentNode
			parent.classList.toggle('open')
		},

		stateToggleChangeHandler (e) {
			// debounce this event in case the user toggles through the options a few time
			// we don't want to post the new value multiple times
			var target = e.currentTarget
			var input = target.querySelector('input')

			clearTimeout(this.debounceStateToggle)

			this.debounceStateToggle = setTimeout(function () {
				var value = input.value
				var instanceID = target.getAttribute('data-id')

				var obj = {
					'entity': null,
					'uuid': null,
					'instance': []
				}

				// find all instances with this UUID and set their state to 5
				for (var i = this.items.length - 1; i >= 0; i--) {
					var parsedID = parseInt(instanceID)
					if (this.items[i].id === parsedID) {
						if (!obj.entity) {
							obj.entity = this.entityid
							obj.uuid = this.items[i].uuid
						}

						obj.instance.push({
							'id': this.items[i].id,
							'market': this.items[i].market,
							'state': value
						})

						var json = JSON.stringify(obj)

						var url = '/cms/api/instances/save'
						xhrModule.post(url, json, this.updatedInstanceCompleteHandler.bind(this))

						break
					}
				}
			}.bind(this), 300)
		},

		destroySortable: function () {
			if (this.sortableModule) {
				this.sortableModule.destroy()
				this.sortableModule = null
			}
		},

		visibilityToggleChangeHandler (e) {
			var id = parseInt(e.currentTarget.getAttribute('data-id'))

			// find the instance with this ID
			for (var i = this.items.length - 1; i >= 0; i--) {
				var parsedID = parseInt(id)

				if (this.items[i].id === parsedID) {
					var currentState = this.items[i].properties['hide-from-navigation']
					var bool = 'true'
					if (currentState === 'true') bool = 'false'

					// change state
					this.items[i].properties['hide-from-navigation'] = bool

					// find ID for hide from navigation prop
					var propertyID = this.entity.properties['hide-from-navigation'].id

					var obj = {
						instance: this.items[i].uuid,
						market: this.items[i].market,
						property: propertyID,
						value: bool
					}

					var json = JSON.stringify(obj)
					var url = '/cms/api/instances/update'
					xhrModule.post(url, json, this.updatedInstanceCompleteHandler.bind(this))
				}
			}
		},

		updatedInstanceCompleteHandler (data) {
			general.saveAnimation()
		},

		sortBtnClickHandler (e) {
			e.preventDefault()

			var target = e.currentTarget
			var column = target.getAttribute('data-table-column')
			var sort = target.getAttribute('data-sort')

			// reset previous sort target
			if (this.previousSortTarget) {
				if (this.previousSortColumn !== column) this.previousSortTarget.setAttribute('data-sort', '')
			}

			this.previousSortTarget = target
			this.previousSortColumn = column

			switch (sort) {
				case '':
					sort = 'asc'
					break
				case 'asc':
					sort = 'desc'
					break
				case 'desc':
					sort = ''
					break
			}

			target.setAttribute('data-sort', sort)
			this.sortProp = column
			this.sortDirection = sort

			if (sort === '') {
				// remove item
				localStorage.removeItem('cms_sort_' + this.entityid)
			} else {
				// save chosen sorting
				var sortObj = {
					'property': column,
					'direction': sort
				}
				localStorage.setItem('cms_sort_' + this.entityid, JSON.stringify(sortObj))
			}
			this.sortResults()
		},

		sortResults () {
			// sort items
			this.items.sort(function (a, b) {
				if (!this.sortDirection) {
					// sort by ID
					if (a.id < b.id) {
						return -1
					}

					if (a.id > b.id) {
						return 1
					}
				} else {
					if (this.sortProp === 'state') {
						// sort on state
						if (a.state < b.state) {
							return this.sortDirection === 'asc' ? -1 : 1
						}

						if (a.state > b.state) {
							return this.sortDirection === 'asc' ? 1 : -1
						}
					} else {
						// sort on property
						var propA = null
						var propB = null

						if (this.sortProp === 'created') {
							propA = a.created
							propB = b.created
						} else {
							if (this.entity.properties[this.sortProp].settings.type.value === 'Reference') {
								propA = a['ref-' + this.sortProp]
								propB = b['ref-' + this.sortProp]
							} else {
								propA = a.properties[this.sortProp]
								propB = b.properties[this.sortProp]

								// check for arrays (object in vuejs)
								if (typeof propA === 'object') {
									propA = propA.toString()
								}

								if (typeof propB === 'object') {
									propB = propB.toString()
								}
							}
						}

						if (propA === undefined) propA = ''
						if (propB === undefined) propB = ''

						// when the prop is a string we can lowercase it to prevent case sensitivity
						if (typeof propA === 'string') {
							propA = propA.toLowerCase()
						}

						if (typeof propB === 'string') {
							propB = propB.toLowerCase()
						}

						if (propA < propB) {
							return this.sortDirection === 'asc' ? -1 : 1
						}

						if (propA > propB) {
							return this.sortDirection === 'asc' ? 1 : -1
						}
					}
				}

				return 0
			}.bind(this))
		},

		fetchSavedSorting () {
			// fetch saved sorting value
			var savedSorting = localStorage.getItem('cms_sort_' + this.entityid)
			if (savedSorting) {
				savedSorting = JSON.parse(savedSorting)
				this.sortProp = savedSorting.property
				this.sortDirection = savedSorting.direction
			}
		},

		openSidebarClickHandler (e) {
			e.preventDefault()

			// find the offset top for the marker in the sidebar
			this.sidebarData.marketOffsetTop = e.currentTarget.getBoundingClientRect().top + (e.currentTarget.getBoundingClientRect().height / 2) - 9

			const instanceUUID = e.currentTarget.getAttribute('data-uuid')
			this.sidebarData.instanceUUID = instanceUUID
			this.sidebarData.entity = this.entity
			this.sidebarData.market = this.activeLanguage

			this.$refs.sidebar.toggle(e.currentTarget)
		},

		sidebarSaveCallback (e) {
			// refresh data
			this.fetchData()
		},

		downloadClickHandler (e) {
			e.preventDefault()

			// add loader
			this.body.classList.add('loading')

			const url = `/cms/api/instances/download?entity=${this.entityid}`
			xhrModule.download(url, this.downloadCSVCompleteHandler.bind(this))
		},

		downloadCSVCompleteHandler (data) {
			var blob = data.blob
			var filename = data.filename.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1]

			var file = window.URL.createObjectURL(blob)

			var a = document.createElement('a')
			a.href = file
			a.download = filename
			a.click()
			a.remove()

			this.body.classList.remove('loading')
		},

		duplicateClickHandler (e) {
			e.preventDefault()

			const instanceUUID = e.currentTarget.getAttribute('data-id')
			var url = `/cms/api/instances/copy`
			let obj = {
				uuid: instanceUUID
			}

			const json = JSON.stringify(obj)
			xhrModule.post(url, json, this.duplicateInstanceCompleteHandler.bind(this))
			this.body.classList.add('loading')
		},

		duplicateInstanceCompleteHandler (data) {
			this.body.classList.remove('loading')

			// all changes have been posted
			this.fetchData()
			this.updatedInstanceCompleteHandler()
		}
	},

	watch: {
		$route (to) {
			this.destroySortable()
			this.entityid = to.params.entityid
			this.sortable = 'false'
			this.nestable = 'false'
			this.items = []
			this.columns = null
			this.totalCount = null
			this.permissions = {
				'add': false,
				'edit': false,
				'delete': false
			}
			this.markets = null
			this.linkedEntity = null
			this.mainSlug = general.getMainSlug()
			this.entity = null
			this.instancesTree = null
			this.fetchSavedSorting()
			this.fetchData()

			// update codebar
			this.$root.$emit('updateCodebar', this.entityid)
		}
	}
}
</script>
